import logoBlanco from '../../assets/logo-blanco.svg'

export default function Footer(){
    return (
        <footer>
            <img src={logoBlanco} alt="" />
        </footer>
    )
}